import { useContext } from 'react';
import { AuthContext } from '@/contexts/AuthContext';
export function useAuth() {
  const v = useContext(AuthContext);
  if (!v) throw new Error('useAuth must be inside AuthProvider');
  return v;
}
